module.exports = __webpack_public_path__ + "d67cbb26e2cba00601b3da87b678b805.MP3";